import { render, staticRenderFns } from "./AnimePanelComponent.vue?vue&type=template&id=4ed79e42&"
import script from "./AnimePanelComponent.vue?vue&type=script&lang=ts&"
export * from "./AnimePanelComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports